import React from "react";
import "./Hero.css";
import {HeroImg} from "../../assets/images";
import {CircleDotHoverButton, PureCounter} from "../";

const Hero = () => {
  return (
    <section className="wt-hero-3-area">
      <svg aria-hidden="true" className="svg-grid">
        <defs>
          <pattern
            id="hero"
            width="80"
            height="80"
            x="50%"
            y="-1"
            patternUnits="userSpaceOnUse"
          >
            <path d="M.5 200V.5H200" fill="none"></path>
          </pattern>
        </defs>
        <rect
          width="100%"
          height="100%"
          strokeWidth="0"
          fill="url(#hero)"
          className="my-rect"
        ></rect>
      </svg>
      <span
        style={{
          border: "0",
          clip: "rect(0, 0, 0, 0)",
          height: "1px",
          margin: "-1px",
          overflow: "hidden",
          padding: "0",
          position: "absolute",
          width: "1px",
          whiteSpace: "nowrap",
          wordWrap: "normal",
        }}
      ></span>
      <div className="hero-spotlight"></div>
      <div className="container">
        <div className="hero-title-area">
          <div className="col-xl-9">
            <h1 className="wt-hero-3-title fade_animation">
              <span className="weight">Hello</span> i’m Deep N. Kapadia,
              professional freelancer{" "}
              <span className="color">with 9+ years</span>{" "}
              <span className="weight">experience</span>
            </h1>
          </div>
        </div>
        <div className="hero-counter-content">
          <div className="text-counter-wrap">
            <div className="hero-play-btn">
              <p>
                Turning Concepts/Ideas <br />
                into Digital Reality
              </p>
            </div>
            <p className="hero-top-paragraph">
              I craft fast, responsive, and visually refined interfaces with
              clean code and modern frameworks—delivering intuitive user
              experiences across every device.
            </p>
            <div className="hero-top-button">
              <CircleDotHoverButton to="/projects" />
            </div>
          </div>
          <div className="hero-image">
            <div className="image">
              <img src={HeroImg} alt="img" />
            </div>
          </div>
          <div className="text-counter-wrap">
            <div className="text-counter-box">
              <div
                className="fade_animation"
                data-fade-from="top"
                data-on-scroll="1"
                data-delay="0.3"
              >
                <h2 className="text-counter-title">
                  $
                  <PureCounter start={0} end={100} duration={10} />
                  k+
                </h2>
              </div>
              <div className="wt-team-counter-text">
                <p className="wt-team-counter-paragraph">
                  Earned Globally & Counting
                </p>
              </div>
            </div>
            <div className="text-counter-box">
              <div
                className="fade_animation"
                data-fade-from="top"
                data-on-scroll="1"
                data-delay="0.3"
              >
                <h2 className="text-counter-title">
                  <PureCounter start={0} end={700} duration={5} />+
                </h2>
              </div>
              <div className="wt-team-counter-text">
                <p className="wt-team-counter-paragraph">
                  Work Delivered Over the Years
                </p>
              </div>
            </div>
            <div className="text-counter-box">
              <div
                className="fade_animation"
                data-fade-from="top"
                data-on-scroll="1"
                data-delay="0.3"
              >
                <h2 className="text-counter-title">
                  <PureCounter start={0} end={101} duration={10} />+
                </h2>
              </div>
              <div className="text-counter-title">
                <p className="bottom-counter-paragraph">
                  Satisfied Clients and Counting
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="hero-social hero-footer-right-social fade_animation">
        <ul>
          <li>
            <a
              href="https://www.linkedin.com/in/deep-kapadia-4872a0117/"
              target="_blank"
            >
              <span className="active-media">LnkedIn</span>
              <span className="hover-media">
                <i className="fa-brands fa-linkedin-in"></i>
              </span>
            </a>
          </li>
          <li>
            <a href="https://github.com/Deepkapadia" target="_blank">
              <span className="active-media">GitHub</span>
              <span className="hover-media">
                <i className="fa-brands fa-github"></i>
              </span>
            </a>
          </li>
          <li>
            <a href="https://www.facebook.com/deep.kapadia.927" target="_blank">
              <span className="active-media">facebook</span>
              <span className="hover-media">
                <i className="fa-brands fa-facebook"></i>
              </span>
            </a>
          </li>
        </ul>
      </div>
    </section>
  );
};

export default Hero;
